import { EMPTY_STRING } from "../config";

export const arcSecToMin = (sec?: number) => {
  if (!sec) return EMPTY_STRING + ' min ' + EMPTY_STRING + ' sec';
  const time = new Date((sec ?? 0) * 1000);
  return time.getMinutes() +' min ' + time.getSeconds() + ' sec';
};